module.exports = __webpack_public_path__ + "static/media/energyCEyeContour.26f41a2e.png";